import { TimeGatePlus } from "./TimeGatePlus.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  TimeGatePlus
};
//# sourceMappingURL=index.js.map
